import { t } from "@lingui/macro";
import * as React from "react";
import { G, Path } from "react-native-svg";
import { Defs, ClipPath } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const ChatIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 16" title={t`Chat`} {...props}>
    <G clipPath="url(#a)">
      <Path
        fill="currentColor"
        d="m8.763.751.316.024a6.876 6.876 0 0 1 6.145 6.146l.025.315V7.637l-.01.401a6.804 6.804 0 0 1-.72 2.684v-.001a6.888 6.888 0 0 1-6.158 3.806H8.36a6.8 6.8 0 0 1-2.792-.593l-3.831 1.278a.75.75 0 0 1-.95-.95l1.278-3.831A6.89 6.89 0 0 1 8.361.75V.75h.361l.041.001Zm-3.147 1.4.339.668-.003.002-.33.179a5.39 5.39 0 0 0-2.65 4.64 5.303 5.303 0 0 0 .57 2.405.75.75 0 0 1 .042.575l-.899 2.694 2.695-.898.144-.032a.751.751 0 0 1 .43.074c.746.376 1.57.572 2.405.57h.001a5.391 5.391 0 0 0 4.818-2.98l.002-.003c.377-.745.572-1.57.57-2.404v-.334A5.375 5.375 0 0 0 8.693 2.25h-.334a5.304 5.304 0 0 0-2.404.57l-.363-.717.024.047Z"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h16v16H0z" />
      </ClipPath>
    </Defs>
  </Icon>
);
